import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCtycxaa0tkNOLuMTsMCmv4svqiUW4RXhg",
  authDomain: "chat3-c77aa.firebaseapp.com",
  projectId: "chat3-c77aa",
  storageBucket: "chat3-c77aa.appspot.com",
  messagingSenderId: "661834018569",
  appId: "1:661834018569:web:fb5818d44d9bc6245badd8",
  measurementId: "G-XFPQ3EVWMQ"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth();
export const storage = getStorage();
export const db = getFirestore();

